import { Project } from 'model';
import { ManPage } from 'components/ManPage/ManPage';

export function Projects({ projects }: { projects: Project[] }): JSX.Element {
  return (
    <ManPage
      name="projects"
      manual="Code & Side Quests"
      sections={[
        { heading: 'NAME', body: 'projects - personal and open-source work' },
        {
          heading: 'ENTRIES',
          body: (
            <>
              {projects.map((p, i) => (
                <div key={i}>
                  <div className="man-sub">
                    <a href={p.url}>{p.title}</a>
                  </div>
                  <div>{p.description}</div>
                  <div>stack: {p.techStack}</div>
                  {'\n'}
                </div>
              ))}
            </>
          )
        }
      ]}
    />
  );
}
